export default function MykonosPage() {
  return (
    <div
      className="relative w-full h-screen bg-cover bg-center text-white"
      style={{ backgroundImage: "url('/bg.webp')" }}
    >
      {/* Overlay (необязательно, если нужно затемнение) */}
      <div className="absolute inset-0 bg-black/10" />

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4">
        <h1 className="font-saol text-white text-5xl md:text-8xl tracking-tight mb-6">
          NAMMOS DUBAI
        </h1>
        <p className="max-w-3xl text-sm md:text-base text-white uppercase tracking-wide leading-relaxed">
          When Mediterranean elegance met Dubai’s magic, Nammos Dubai was born
          and the golden dunes that felt so familiar emitted a fresh allure
          under the Arabian sun.
        </p>
      </div>
    </div>
  );
}
